import React, { useEffect, useState } from "react";
import { range } from "range";
import getItemQuantityText from "./getItemQuantityText";
import getMinBuyForQuantityDropdown from "./getMinBuyForQuantityDropdown";
interface Props {
  quantity: string;
  minBuy: number;
  mustBuy: number;
  unitOfMeasure: string;
  handleQuantityChange: (value: string) => void;
}
const QuantityDropdown = ({
  quantity,
  minBuy,
  mustBuy,
  unitOfMeasure,
  handleQuantityChange
}: Props) => {
  const [quantityChanged, setQuantityChanged] = useState(false);
  const numberOfOptions = 15;
  const itemQuantityText = getItemQuantityText(unitOfMeasure);
  const startQuantity = getMinBuyForQuantityDropdown({
    minBuy,
    mustBuy
  });
  const handleOnChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setQuantityChanged(true);
    handleQuantityChange(event.target.value);
  };
  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    !quantityChanged && handleQuantityChange(startQuantity.toString());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return <div className="form" data-sentry-component="QuantityDropdown" data-sentry-source-file="QuantityDropdown.tsx">
      <div className="form__group">
        <div className={`form__control-container${quantityChanged ? "" : " no-selection"}`}>
          <select value={quantity} name="qty" className="configure qty-preset-select form__control" onChange={handleOnChange} data-testid="quantity-dropdown">
            {range(0, numberOfOptions).map(index => <option key={index}>{startQuantity + index * mustBuy}</option>)}
            <option value="other">Other</option>
          </select>
          <label className="form__label" htmlFor="requestReason">
            <span className="form__label-text">{itemQuantityText}</span>
          </label>
          <i className="icon-down-micro form__control-icon form__control-icon--lg" />
        </div>
      </div>
    </div>;
};
export default QuantityDropdown;